const t = {
  name: "ExpandVertically",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.9997 6.41436L15.9997 10.4144L17.4139 9.00015L11.9997 3.58594L6.58545 9.00015L7.99966 10.4144L11.9997 6.41436Z" fill="currentColor"/>
<path d="M12 17.586L7.99996 13.586L6.58575 15.0002L12 20.4144L17.4142 15.0002L16 13.586L12 17.586Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as ExpandVertically
};
